/* eslint-disable react/no-unused-class-component-methods */
'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { search } from '@root/utility'

import { handleChange } from '@/Form/Functions/eventsHandling'

import Layout from '@Layout/BackOffice'

import OrderInfos from '@/OrderInfos'

import FormElement from '@/Form/toolkit/FormElement'

import Loader    from '@Pure/Loader'
import SearchBar from '@Pure/SearchBar'

const { qwest, app } = window;

export default class TicketsManagementPage extends Component
{
	state =
	{
		orders: null,
		actions: [],
		searched:
		{
			value: '',
			transaction: ''
		},

		filter_status: ['processing'],

		form_data:
		{
			'status[processing]': true
		},

		status_messages: { },
		selection: []
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.push(
		{
			event: 'documentClick',
			cb: component.handleDocumentClick
		});

		let filter_query =
		{
			sort: 'createdAt DESC',

			'products.pricing_type': 'show_product',

			or:
			[
				{
					status: 'new',
					'payment.method': { '!=': 'CC' }
				},
				{
					status: 'processing'
				}
			]
		};

		qwest.post('/fetch/list-admin-tickets-orders').then(function (xhr, response)
		{
			component.setState({ orders: response.orders || [] });
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);

			component.setState({ orders: [] });
		});
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'documentScroll',
			cb: component.stickTable
		});

		app.push(
		{
			event: 'createdShipping',
			cb: component.handleShippingCreation
		});

		app.push(
		{
			event: 'changedProviderOrder',
			cb: component.handleProviderOrderChange
		});

		app.push(
		{
			event: 'changedProviderTransaction',
			cb: component.handleProviderTransactionChange
		});

		app.push(
		{
			event: 'providerOrdersMassAction',
			cb: component.handleProviderMassAction
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		component.unStickTable();

		component.stick_table    = undefined;
		component.sticky_columns = undefined;
		component.stick_header   = undefined;

		app.delete(
		{
			event: 'documentScroll',
			cb: component.stickTable
		});

		app.delete(
		{
			event: 'createdShipping',
			cb: component.handleShippingCreation
		});

		app.delete(
		{
			event: 'changedProviderOrder',
			cb: component.handleProviderOrderChange
		});

		app.delete(
		{
			event: 'changedProviderTransaction',
			cb: component.handleProviderTransactionChange
		});

		app.delete(
		{
			event: 'providerOrdersMassAction',
			cb: component.handleProviderMassAction
		});
	}

	handleProviderMassAction = (params) =>
	{
		const component = this, props = this.props, state = this.state;

		let number = params.number, action = params.action;

		params.data.forEach(function (infos)
		{
			let order = (state.orders || [])
			.find(order => order.id === infos.order.id);

			order.products.forEach(function (product)
			{
				let grouped = true;

				if ([true, 'true'].includes(product.is_individuel))
				{
					grouped = false;
				}

				if ([true, 'true'].includes(product.price.nominative))
				{
					grouped = false;
				}

				if (grouped)
				{
					let has_changed = Object.keys(infos.selected || { })
					.find(function (ticket_id)
					{
						return [true, 'true'].includes(infos.selected[ticket_id]);
					});

				// No change in this product, ignoring it.
					if (typeof has_changed === 'undefined')
					{
						return;
					}

					if (action === 'transaction')
					{
						product.provider_transaction = number;
					}
					else
					{
						product.provider_order = number;
					}
				}
				else
				{
					let updated_tickets = infos.selected;

					Object.keys(product.tickets || { })
					.filter(function (ticket_id)
					{
						if ([true, 'true'].includes(updated_tickets[ticket_id]))
						{
							if (action === 'transaction')
							{
								product.tickets[ticket_id].provider_transaction = number;
							}
							else
							{
								product.tickets[ticket_id].provider_order = number;
							}
						}
					});
				}
			});
		});

		component.setState(
		{
			orders: state.orders,
			selection: []
		});
	}

	handleProviderTransactionChange = (params) =>
	{
		const component = this, props = this.props, state = this.state;

		const { ticket_id } = params;

		let order = (state.orders || []).find(data => data.id === params.order.id);

		if (!order) return;

		let product = order.products.find(function (product)
		{
			if (ticket_id)
			{
				return product.price.ref === params.product.price.ref &&
					product.tickets[ticket_id];
			}

			return product.price.ref === params.product.price.ref;
		});

		if (!product) return;

		if (params.ticket_id && product.tickets[params.ticket_id])
		{
			product.tickets[params.ticket_id].provider_transaction = params.number;
		}
		else
		{
			product.provider_transaction = params.number;
		}

		component.setState(
		{
			orders: state.orders
		});
	}

	handleProviderOrderChange = (params) =>
	{
		const component = this, props = this.props, state = this.state;

		const { ticket_id } = params;

		let order = (state.orders || []).find(data => data.id === params.order.id);

		if (!order) return;

		let product = order.products.find(function (product)
		{
			if (ticket_id)
			{
				return product.price.ref === params.product.price.ref &&
					product.tickets[ticket_id];
			}

			return product.price.ref === params.product.price.ref;
		});

		if (!product) return;

		if (ticket_id)
		{
			product.tickets[ticket_id].provider_order = params.number;
		}
		else
		{
			product.provider_order = params.number;
		}

		component.setState(
		{
			orders: state.orders
		});
	}

	handleShippingCreation = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		const shipping = data.shipping;

		if (!shipping) return;

		(state.orders || []).forEach(function (order)
		{
			if (data.completed_orders.includes(order.id))
			{
				order.status = 'completed';
			}

			const match = (shipping.products || []).concat(shipping.items || [])
			.some(item => item.order_id === order.id);

			if (!match) return;

			order._shippings = order._shippings || [];

			order._shippings.push(shipping);
		});

		component.setState(
		{
			orders: state.orders,
			selection: []
		});
	}

	handleCanceledProduct = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		const order = (state.orders || []).find(data => data.id === data.order_id);

		if (!order) return;

		order.products.forEach(function (product)
		{
			if (data.ticket_id)
			{
				product.tickets[data.ticket_id].status = 'canceled';
			}
			else
			{
				Object.keys(product.tickets).forEach(function (ticket_id)
				{
					product.tickets[ticket_id].status = 'canceled';
				});
			}
		});

		state.selection = state.selection.filter(function (item)
		{
			if (data.ticket_id)
			{
				if (item.selected[data.ticket_id])
				{
					item.selected[data.ticket_id] = false;
				}
			}
			else
			{
				Object.keys(data.product.tickets).forEach(function (ticket_id)
				{
					if (item.selected[ticket_id])
					{
						item.selected[ticket_id] = false;
					}
				});
			}
		});

		component.setState(
		{
			orders: state.orders,
			selection: state.selection
		});
	}

	handleOrderSelection = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		state.selection = state.selection.filter(function (selected_data)
		{
			return selected_data.order.id !== data.order.id;
		});

		state.selection.push(_.cloneDeep(data));

		component.setState(
		{
			selection: state.selection
		});
	}

	handleFilterChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		handleChange.bind(component)(e, data);

		if (!e) return;

		let value = e.target.checked;
		let name  = e.target.name.split('status[').join('').split(']').join('');

		if (value)
		{
			component.state.filter_status.push(name);
		}
		else
		{
			component.state.filter_status = component.state.filter_status
				.filter(status => status !== name);
		}

		component.setState(
		{
			filter_status: component.state.filter_status
		});
	}

	handleDocumentClick = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!source && state.actions.length > 0)
		{
			component.setState({ actions: [] });

			return;
		}

		if (source && source.label === 'orderManagementActions')
		{
			component.state.actions = component.state.actions
			.filter(function (action)
			{
				return action.type === source.type && action.order.id === source.order_id;
			});

			component.setState({ actions: component.state.actions });
		}
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props, state = this.state;

		state.searched.value = value;
		state.searched.data = search ? search.data : undefined;

		component.setState({ searched: state.searched });

		app.emit('searchChange');
	}

	handleTransactionSearch = (value, search) =>
	{
		const component = this, props = this.props, state = this.state;

		state.searched.transaction = value;

		component.setState({ searched: state.searched });

		app.emit('searchChange');
	}

	handleClick = (e, type, data) =>
	{
		const component = this, props = this.props, state = this.state;

		e.stopPropagation();

		let find;

		component.state.actions = component.state.actions
		.filter(function (action)
		{
			if (action.order.id === data.id)
			{
				find = true;

				return false;
			}

			return true;
		});

		if (!find)
		{
			component.state.actions.push(
			{
				type: type,
				order: data,
				loading: false
			});

			app.emit('documentClick',
			{
				label: 'orderManagementActions',
				type: type,
				order_id: data.id
			});
		}

		component.setState(
		{
			actions: component.state.actions
		});
	}

	handleAction = (e, action) =>
	{
		const component = this, props = this.props;

		e.stopPropagation();

		app.emit('documentClick',
		{
			label: 'orderManagementAction',
			order: action.order
		});

		let state_action = component.state.actions.find(function (state_action)
		{
			if (state_action.order.id === action.order.id &&
				state_action.type === action.type)
			{
				state_action.loading = false;

				return true;
			}
		});

		state_action.loading = true;

		component.setState({ actions: component.state.actions });

		let options = { id: action.order.id };

		if (action.model)
		{
			options.model = action.model;
		}

		qwest.post(action.post, options)
		.then(function (xhr, response)
		{
			component.state.actions = component.state.actions.filter(function (state_action)
			{
				if (state_action.order.id === action.order.id &&
					state_action.type === action.type)
				{
					state_action.loading = false;

					return false;
				}

				return true;
			});

			let state_order = (component.state.orders || [])
			.find(order => order.id === action.order.id);

			if (action.post === '/order/validate-payment')
			{
				state_order.paid = 'true';

				if (state_order.status === 'new')
				{
					state_order.status = 'processing';
				}
			}
			else if (action.post === '/order/delete')
			{
				component.state.orders = (component.state.orders || [])
				.filter(order=> order.id !== state_order.id);
			}
			else if (action.post === '/order/set-status-processing')
			{
				state_order.status = 'processing';
			}
			else if (action.post === '/order/set-status-completed')
			{
				state_order.status = 'completed';
			}

			component.setState(
			{
				orders: component.state.orders,
				actions: component.state.actions
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, response);
		});
	}

	export = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading_export: true
		});

		qwest.post('/provider-order/export')
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading_export: false
			});

			app.emit('open__ExportedProvidersOrdersModal',
			{
				url: response.pathname
			});
		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const searched      = state.searched.value;
		const filter_status = state.filter_status;

		let days = [];

		let orders = (state.orders || []).filter(function (order)
		{
			if (searched.length <= 1 && filter_status.length === 0)
			{
				return true;
			}

			let matches = 0;

			if (filter_status.length > 0)
			{
				if (filter_status.includes(order.status) === false)
				{
					return false;
				}
			}

			matches += search(order.number, searched);
			matches += search(order.user.firstname + ' ' + order.user.lastname, searched);

			order.products.forEach(function (product)
			{
				matches += search(product.price.ref, searched);
				matches += search(product.name, searched);
			});

			return matches > 0;
		});

		if (state.searched.transaction && state.searched.transaction.length > 1)
		{
			orders = _.cloneDeep(orders).filter(function (order)
			{
				order.products = order.products.filter(function (product)
				{
					let matches = 0;

				/**
				 * Search transaction in products data
				 **/
					if (product.provider_transaction)
					{
						matches += search(product.provider_transaction, state.searched.transaction);
					}

					if (matches > 0) return true;

				/**
				 * Search transaction in tickets data
				 * and filter out tickets that have not the searched transaction
				 **/
					Object.keys(product.tickets || { }).forEach(function (ticket_id)
					{
						let found = 0;

						if (product.tickets[ticket_id].provider_transaction)
						{
							found += search(product.tickets[ticket_id].provider_transaction,
								state.searched.transaction);
						}

						matches += found;

						if (found === 0)
						{
							delete product.tickets[ticket_id];
						}
					});

					return matches > 0;
				});

				return order.products.length > 0;
			});
		}

		orders = orders.map(function (order)
		{
			let loaders = { }, actions = {};

			['payment', 'status'].forEach(function (name)
			{
				let action = state.actions
				.find(action => action.order.id === order.id && action.type === name);

				if (action && action.loading === true)
				{
					loaders[name] =
					(
						<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
					);
				}
			});

			let completed_btn =
			(
				<button type="button"
					className="c-order-infos__actions-btn" onClick={ function (e)
					{
						component.handleAction(e,
						{
							type: 'status',
							post: '/order/set-status-completed',
							order: order
						});
					} }>
					Passer « en terminée »
				</button>
			);

			if ([true, 'true'].includes(order.paid) === false)
			{
				actions.payment =
				(
					<div className="c-order-infos__actions">
						<button type="button"
							className="c-order-infos__actions-btn"
							onClick={ function (e)
							{
								component.handleAction(e,
								{
									type: 'payment',
									post: '/order/validate-payment',
									order: order
								});
							} }>
							Valider le paiement
						</button>

						{ loaders['payment'] }
					</div>
				);
			}

			if ([false, 'false'].includes(order.paid) ||
				['support@panda-one.fr'].includes(order.user.login))
			{
				let change_status;

				if (order.status === 'new')
				{
					change_status =
					(
						<button type="button"
							className="c-order-infos__actions-btn" onClick={ function (e)
						{
							component.handleAction(e,
							{
								type: 'status',
								post: '/order/set-status-processing',
								order: order
							});
							} }>
							Passer « en traitement »
						</button>
					);
				}

				if (order.status === 'completed')
				{
					completed_btn = undefined;
				}

				let delete_order;

				if (order.number && order.number.indexOf('SYNER180118-') === 0)
				{
					delete_order =
					(
						<button type="button"
							className="c-order-infos__actions-btn"
							onClick={ function (e)
							{
								component.handleAction(e,
								{
									type: 'status',
									post: '/order/delete',
									order: order,
									model: 'order'
								});
							} }>
							Supprimer la commande
						</button>
					);
				}

				actions.status =
				(
					<div className="c-order-infos__actions">

						{ delete_order }

						{ change_status }

						{ completed_btn }

						{ loaders['status'] }

					</div>
				);
			}
			else if (order.status === 'processing')
			{
				actions.status =
				(
					<div className="c-order-infos__actions">

						{ completed_btn }

						{ loaders['status'] }

					</div>
				);
			}

			Object.keys(actions).forEach(function (name)
			{
				let action = state.actions
				.find(action => action.order.id === order.id && action.type === name);

				if (!action)
				{
					actions[name] = undefined;
				}
			});

			let day = window.moment(order.createdAt).startOf('day').format();
			let show_date = false;

			if (days.includes(day) === false)
			{
				days.push(day);

				show_date = true;
			}

			return (
				<OrderInfos key={ order.id } data={ order }
					shippings={ order._shippings || [] }
					onClick={ component.handleClick }
					admin={ true } ticket_admin={ true } open_by_default={ true }
					actions={ actions } show_date={ show_date }
					onSelection={ component.handleOrderSelection }
				/>
			);
		});

		let header =
		(
			<div className="c-order-infos--header">

				<div className="c-order-infos__order">

					<div className="c-order-infos__number">Commande n°</div>

					<div className="c-order-infos__total-price">Prix total</div>

					<div className="c-order-infos__text">Informations d'achat</div>

					<div className="c-order-infos__payment">Paiement</div>

					<div className="c-order-infos__status">État</div>

					<div className="c-order-infos__bill">Facture</div>

				</div>

			</div>
		);

		let export_loader;

		if (state.loading_export === true)
		{
			export_loader =
			(
				<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
			);
		}

		const fetch_loader = state.orders === null ?
		(
			<div className="u-positioned u-padding-bottom-30 u-padding-top-30
				u-full-width">
				<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
			</div>
		)
		: undefined;

		var output =
		(
			<Layout history={ props.history }
				page_title="Commandes de la billetterie spectacle">

				<div className="page-content orders-management-page">

					<div className="u-negative-margins">

						<div className="o-grid u-margin-bottom-15 order-management-filters">

							<div className="o-grid__item-7 u-flex u-content-between">
								<SearchBar hide_btn={ true }
									placeholder="Recherche par commande"
									handleChange={ component.handleSearch }
									value={ state.searched.value }
								/>

								<SearchBar hide_btn={ true } placeholder="Numéro de transaction"
									handleChange={ component.handleTransactionSearch }
									value={ state.searched.transaction }
								/>
							</div>

							<div className="o-grid__item-5">

								<FormElement name="status[new]"
									type="checkbox" data={ state.form_data }
									onChange={ component.handleFilterChange }
									status={ state.status_messages }
									label="En attente"
								/>

								<FormElement name="status[processing]"
									type="checkbox" data={ state.form_data }
									onChange={ component.handleFilterChange }
									status={ state.status_messages }
									label="En traitement"
								/>

							</div>

						</div>

						<div className="o-grid u-margin-top-15 u-margin-bottom-15">

							<div className="o-grid__item-4">
								<button type="button"
									className="c-btn u-margin-right-10"
									onClick={ component.export }>
									Export fournisseurs
									{ export_loader }
								</button>
							</div>

							<div className="o-grid__item-8 u-text-right">

								<button type="button" className="c-btn u-margin-right-10"
									onClick={ function (e)
									{
										app.emit('open__ProviderOrderMassActionModal',
										{
											data: state.selection,
											action: 'order_number'
										});
									} }>
									Saisir des numéros de commande
								</button>

								<button type="button"
									className="c-btn u-margin-right-10"
									onClick={ function (e)
									{
										app.emit('open__ProviderOrderMassActionModal',
										{
											data: state.selection,
											action: 'transaction'
										});
									} }>
									Saisir des numéros de transaction
								</button>

								<button type="button"
									className="c-btn" id="create-shipping-button"
									onClick={ function (e)
									{
										app.emit('open__ShippingModal',
										{
											selection: state.selection,
											onValidate: function (response)
											{
												component.setState(
												{
													selection: []
												});
											}
										});
									} }>
									Traiter les commandes sélectionnées
								</button>
							</div>

						</div>

					</div>

					<div id="sticky-order-management">

						{ header }

						{ orders }

						{ fetch_loader }

					</div>

				</div>

			</Layout>
		);

		return output;
	}

	stickTable = () =>
	{
		const component = this, props = this.props, state = this.state;

		let stick_table  = component.stick_table, stick_header = component.stick_header;
		let create_order = component.stick_button;

		if (!component.stick_table)
		{
			stick_table  = document.getElementById('sticky-order-management');
			stick_header = stick_table.querySelector('.c-order-infos--header');
			create_order = document.getElementById('create-shipping-button');

			component.stick_table  = stick_table;
			component.stick_header = stick_header;
			component.stick_button = create_order;
		}

		stick_table.style.top = (47+15) + (36+15) + 'px';

		let top_distance = stick_table.getBoundingClientRect().top;

		let distance = 287;

		if (stick_header.classList.contains('js-sticky')) distance = 280;

		if (top_distance < distance)
		{
			stick_header.style.width = stick_header.getBoundingClientRect().width + 'px';

			window.requestAnimationFrame(function ()
			{
				stick_header.classList.add('js-sticky');
				create_order.classList.add('js-sticky');
			});
		}
		else
		{
			component.unStickTable();
		}
	}

	unStickTable = () =>
	{
		const component = this, props = this.props, state = this.state;

		let stick_table = component.stick_table, stick_header = component.stick_header;
		let create_order = component.stick_button;

		if (!stick_table)
		{
			stick_table  = document.getElementById('sticky-order-management');
			stick_header = stick_table.querySelector('.c-order-infos--header');
			create_order = document.getElementById('create-shipping-button');

			component.stick_table  = stick_table;
			component.stick_header = stick_header;
			component.stick_button = create_order;
		}

		stick_table.style.top = '';

		stick_header.classList.remove('js-sticky');
		stick_header.style.width = '';

		create_order.classList.remove('js-sticky');
	}
}